"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLOCK_CONNECTION_RULES = exports.BlockActiveStatus = exports.BlockType = exports.TOP_LEVEL_BLOCK_ID = exports.TABLE_BLOCKS = void 0;
exports.TABLE_BLOCKS = "blocks";
exports.TOP_LEVEL_BLOCK_ID = "TOP_LEVEL_BLOCK_ID";
var BlockType;
(function (BlockType) {
    BlockType["team"] = "team";
    BlockType["project"] = "project";
    BlockType["input"] = "input";
    BlockType["processor"] = "processor";
})(BlockType || (exports.BlockType = BlockType = {}));
var BlockActiveStatus;
(function (BlockActiveStatus) {
    BlockActiveStatus["active"] = "active";
    BlockActiveStatus["inactive"] = "inactive";
})(BlockActiveStatus || (exports.BlockActiveStatus = BlockActiveStatus = {}));
exports.BLOCK_CONNECTION_RULES = {
    [BlockType.team]: BlockType.project,
    [BlockType.project]: BlockType.input,
    [BlockType.input]: BlockType.processor,
    [BlockType.processor]: BlockType.processor
};
